function initRem() {
  // 最大宽度是540,最大比例是540/375
  var cale = window.window.screen.availWidth / 375
  if (window.window.screen.availWidth > 540) {
    window.document.documentElement.style.fontSize = (540 / 375) * 100 + 'px'
  } else {
    window.document.documentElement.style.fontSize = `${100 * cale}px`
  }
  // var cale = window.screen.availWidth > 540 ? 1 : window.screen.availWidth / 375
  // window.document.documentElement.style.fontSize = `${100 * cale}px`
}
initRem()
window.addEventListener('resize', function() {
  initRem()
})
